var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/modules/_cof.js
// module id = 21
// module chunks = 0 1